import React from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper';
import moment from 'moment'
import Request, { API_URL, MEDIA_URL } from '../../../request'
import countryDefaultFlag from './../../../assets/country-default.jpg'
import { connect } from 'react-redux'
import {
    Card,
    Form,
    Input
} from 'antd'
import PDFFileView from '../../../components/DocumentViews/PDFFileView'

@Form.create()
class ShowKnowledge extends React.Component {
    state = {
        loading: false,
        retrieveKnowledgeDatas: [],
        selectedaCategories: [],
        selectedDocLinks: [],
        selectedCategory: '',
        selectedCountry: '',
        countryFlags: [],
        search_title: '',
        ext: null,
        linkUrl: null
    }

    constructor(props) {
        super(props)
        this.loadAllKnowledgeBases();
    }

    componentDidMount() {
    }

    loadAllKnowledgeBases = (params) => {
        if (!params) {
            params = {}
        }
        if (!params.sortField) {
            params.sortField = '_id'
            params.sortOrder = 'descend'
        }
        Request.showKnowledgeBase(params)
            .then(resp => {
                if (resp) {
                    // console.log(resp.response.data)
                    // let sortedArray = 
                    // console.log(sortedArray)
                    var results = resp.response.data.sort((a, b) => (a.countryId.countryName > b.countryId.countryName) ? 1 : ((b.countryId.countryName > a.countryId.countryName) ? -1 : 0));
                    if (results.length > 0) {
                        var retrieveKnowledgeData = [];
                        var countryFlags = [];
                        for (var mainIndex = 0; mainIndex < results.length; mainIndex++) {
                            let result = results[mainIndex];
                            let countryName = result.countryId ? result.countryId.countryName : false;
                            let flagImage = result.countryId && result.countryId.flagImage[0] ? result.countryId.flagImage[0].url : false;
                            if (countryFlags[countryName] === undefined) {
                                countryFlags[countryName] = [];
                            }
                            countryFlags[countryName] = `${MEDIA_URL}${flagImage}`;

                            let categoryName = result.knowledgeBaseCategoryId ? result.knowledgeBaseCategoryId.name : false;

                            let universityInstitutionName = result.universityId ? result.universityId.universityInstitutionName : false;

                            let links = result.links;
                            let mediaFiles = result.mediaFiles;
                            if (countryName) {
                                if (retrieveKnowledgeData[countryName] === undefined) {
                                    retrieveKnowledgeData[countryName] = [];
                                }
                                if (retrieveKnowledgeData[countryName][categoryName] === undefined) {
                                    retrieveKnowledgeData[countryName][categoryName] = [];
                                }
                                if (links.length > 0) {
                                    for (var linkIndex = 0; linkIndex < links.length; linkIndex++) {
                                        let link = links[linkIndex];
                                        link.universityInstitutionName = universityInstitutionName;
                                        retrieveKnowledgeData[countryName][categoryName].push({
                                            flagImage: flagImage,
                                            links: link
                                        });
                                    }
                                }
                                if (mediaFiles.length > 0) {
                                    for (var mediaIndex = 0; mediaIndex < mediaFiles.length; mediaIndex++) {
                                        let mediaFile = mediaFiles[mediaIndex];
                                        retrieveKnowledgeData[countryName][categoryName].push({
                                            flagImage: flagImage,
                                            links: {
                                                title: (mediaFile.fileTitle !== undefined ? mediaFile.fileTitle : ''),
                                                description: (mediaFile.fileDescription !== undefined ? mediaFile.fileDescription : ''),
                                                link: (mediaFile.files.length > 0 && MEDIA_URL + mediaFile.files[0].url !== undefined ? MEDIA_URL + mediaFile.files[0].url : ''),
                                                universityInstitutionName: universityInstitutionName,
                                                uploadedBy: mediaFile.uploadedBy
                                            }
                                        });
                                    }
                                }
                            }
                        }
                        this.setState({ retrieveKnowledgeDatas: retrieveKnowledgeData, countryFlags: countryFlags });
                    }
                }
            })
            .catch(err => {
                console.log(err)
            })
    }
    getCats = (country) => {
        this.setState({ selectedaCategories: [] });
        var retrieveKnowledgeDatas = this.state.retrieveKnowledgeDatas;
        let innerCategories = retrieveKnowledgeDatas[country];
        var selectedaCategories = [];
        for (let catKey in innerCategories) {
            selectedaCategories.push(catKey);
        }
        this.setState({ selectedaCategories: selectedaCategories, selectedCountry: country });
        this.setState({ selectedDocLinks: [], selectedCategory: '' });
    }
    getDocs = (country, category) => {
        this.setState({ docLinksHtml: [] });
        var retrieveKnowledgeDatas = this.state.retrieveKnowledgeDatas;
        let innerLinks = retrieveKnowledgeDatas[country][category];
        var selectedDocLinks = [];

        for (let linkKey in innerLinks) {
            let link = innerLinks[linkKey];
            selectedDocLinks.push(link)
        }
        this.setState({ selectedDocLinks: selectedDocLinks, selectedCategory: category });
    }
    checkUrlExt = (url) => {
        return url.split(/[#?]/)[0].split('.').pop().trim();
    }
    showFileOutput = (ext, linkUrl) => {
        this.setState({ ext: ext, linkUrl: linkUrl });
    }
    closeDocument = () => {
        this.setState({ ext: null, linkUrl: null });
    }
    render() {
        let windowHeight = (window.innerHeight);
        var retrieveKnowledgeDatas = this.state.retrieveKnowledgeDatas;
        var search_title = this.state.search_title;
        var countryFlags = this.state.countryFlags;
        var countriesHtml = [];
        var categoryHtml = [];
        var linkHtml = [];
        var loopStart = false;
        for (let key in retrieveKnowledgeDatas) {
            let countryFlag = (countryFlags[key] !== undefined ? countryFlags[key] : countryDefaultFlag);
            countriesHtml.push(
                <button className={'tablinks ' + (this.state.selectedCountry === key ? 'active' : '')} key={key} onClick={() => this.getCats(key)}>
                    <img src={countryFlag} className="countryFlag" alt='country Flag' />
                    {key}
                </button>);
            if (!loopStart) {
                loopStart = true;
            }
        }
        var selectedaCategories = this.state.selectedaCategories;
        for (let catKey in selectedaCategories) {
            let selectedaCategory = selectedaCategories[catKey]
            categoryHtml.push(<button key={catKey} className={'tablinks ' + (this.state.selectedCategory === selectedaCategory ? 'active' : '')} onClick={() => this.getDocs(this.state.selectedCountry, selectedaCategory)}>{selectedaCategory}</button>);
        }
        let selectedDocLinks = this.state.selectedDocLinks;
        for (let linkKey in selectedDocLinks) {
            let selectedDocLink = selectedDocLinks[linkKey];
            let links = selectedDocLink.links;
            let linkUrl = links.link;
            let ext = linkUrl ? this.checkUrlExt(linkUrl) : null;
            if (links.title.indexOf(search_title) !== -1 || links.description.toLowerCase().indexOf(search_title.toLowerCase()) !== -1 || (links.universityInstitutionName ? links.universityInstitutionName.toLowerCase().indexOf(search_title.toLowerCase()) !== -1 : links.universityInstitutionName)) {
                linkHtml.push(
                    <div key={linkKey} className="knowledgebase-card">
                        {
                            ext !== 'ext'
                                ?
                                ext === 'ogg' || ext === 'webm' || ext === 'mp4' || ext === 'mpg' || ext === 'wmv' || ext === 'mov' || ext === 'avi'
                                    ?
                                    <video ref={'video_' + linkKey} controls>
                                        <source src={linkUrl} type={'video/' + ext} />
                                        Your browser does not support HTML video.
                                    </video>
                                    :
                                    <img src="/pdf.png" alt="Avatar" />
                                : null
                        }
                        <div className="knowledgebase-container">
                            {links.title ? <h4><b>{links.title}</b></h4> : ''}
                            {links.description ? <p>{links.description}</p> : ''}
                            <p>{links.uploadedBy ? 'Uploaded at ' + moment(links.uploadedBy.time).format('YYYY-MM-DD h:m A') : ''}</p>
                            {links.universityInstitutionName ? <p>{links.universityInstitutionName}</p> : ''}
                            {
                                ext === 'ogg' || ext === 'webm' || ext === 'mp4' || ext === 'mpg' || ext === 'wmv' || ext === 'mov' || ext === 'avi'
                                    ?
                                    <button onClick={() => { this.refs['video_' + linkKey].play() }}>Play</button>
                                    :
                                    <>
                                        <a href={linkUrl} target="_blank" download="" rel='noopener noreferrer'>Download</a>&nbsp;|&nbsp;
                                        <a href="#" onClick={() => { this.showFileOutput(ext, linkUrl) }}>View</a>
                                    </>
                            }

                        </div>
                    </div>
                );
            }
        }
        var ext = this.state.ext;
        var linkUrl = this.state.linkUrl;
        return (
            <PageHeaderWrapper title={'Show Knowledge Base'}>
                {
                    ext != null ?
                        <PDFFileView linkUrl={linkUrl} ext={ext} onClose={this.closeDocument} />
                        : null
                }
                <Card bordered={true}>
                    <div className="knowledgebase-tab-outer">
                        <div className="knowledgebase-tab tab" style={{ height: (windowHeight) + 'px' }}>
                            <button className="default-country-name">Countries</button>
                            {countriesHtml}
                        </div>

                        <div id="London" className="knowledgebase-tabcontent tabcontent active">
                            {categoryHtml.length > 0 ? <div className="knowledgebase-tab tab" style={{ height: (windowHeight) + 'px' }}>
                                <button className="default-category-name">Select Category</button>
                                {categoryHtml}
                            </div> : ''}
                            <div id="London-inner" className="knowledgebase-tabcontent-inner tabcontent active" style={{ height: windowHeight + 'px' }}>
                                <Input
                                    value={search_title}
                                    placeholder={'Search by Title'}
                                    onChange={ei => {
                                        this.setState({
                                            search_title: ei.target.value
                                        })
                                    }}
                                />
                                {
                                    linkHtml.length > 0 ?
                                        linkHtml
                                        : null
                                }
                            </div>
                        </div>
                    </div>
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
})

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ShowKnowledge)
